import { DictionaryActionTypes } from './type';

/** **** action creator ******/

export const resourcesEnumsList: string[] = [
  'MEDICINEFREQ', // 用药频率
  'CERTTYPE', // 证件类型
  'SOCIALSECURITYTYPE', // 社保类型
  'GENDER', // 性别
  'PATIENTRELATION', // 患者关系
  'MARRIAGE', // 婚姻状况
  'BLOODGROUP', // 血型
  'PATIENTTYPE', // 患者类型
  'PROFESSIONALTITLE', // 医生职级
  'INQUIRYTYPE', // 问诊类型
  // 'ORDERSTATUS',   //订单状态
  // 'USERCOUPONSTATUS',  //优惠券状态
  // 'EXPRESSSTATUS'  //快递状态
  // "INQUIRYSTATUS",// 问诊状态
  // "PRESCRIPTIONSTATUS",// 处方单状态
  // "DIAGCODETYPE", //中医西医
  // "PRESCRIPTIONCATEGORY", // 处方类别
  'RANGETIMETYPE', // 血糖测量时间
  'EXPRESSSTATUS', // 快递状态
  'DRUGTYPE', // 药品类型
  'FAVOURTYPE', // 服务包详情里面的优惠类型
  'COUPONUSESCOPE', // 优惠券类型
  'WORKSTATUSENUM', // 医生工作状态
  'CONSULTAPPOINTMENTTIMEENUM', // 医管家咨询可预约时间段
  'MEDICALSERVICESTATUSENUM', // 服务卡状态
  'POLICYVASENUM', // 权益枚举
  'COUPONTYPE', // 优惠券类型
  'HEALTHCHECKSTATUSENUM', // 体检卡逻辑
  'YESORNO', // 通用的 ：是、否
  'HOSPITALDEPARTMENT', // 诊疗科目列表
  'SPECIALISMCLINICENUM', // 专科 类型 ：男科/母婴
  'INQUIRYTIMINGTYPEENUM', // 是否专科视频预约单类型
  'ARTICLETYPEENUM', // 文章类型
  'QUESTIONNAIRERESULTLEVELENUM',  // 结果等级
  'BLOODSUGARMONITORTIMEENUM',
  'PROFESSIONALTITLEPHARMACIST', // 药师职务
  'MEDICALORGANIZATIONLEVELENUM', // 医院等级
  'MEDICALORGANIZATIONRANKAREAENUM', // 医院地区枚举
  'MEDICALORGANIZATIONDEPARTMENTENUM', // 医院科室枚举
  'SYSTEMMODE',// 监管模式枚举
  'PUSHCOMMODITYCHANNEL', // 可以推药的资源applicationId枚举
  'HEALTHINSURANCEENUM', // 好医保六选一
  'CHILDHEALTHINSURESERVICEENUM', // 儿童齿科服务
  'RIGHTSAPPLYCODEENUM', // 肿瘤服务
  'RIGHTSAPPLYATTACHMENTENUM', // 肿瘤服务
  'RIGHTSAPPLYSTATUSENUM', // 肿瘤服务
];

/** **** 获取相应的枚举字段 ******/
export const fetch_dictionary_list = () => ({ type: DictionaryActionTypes.FETCH_DICTIONARY_LIST, resourcesEnumsList });
